"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var X509Certificate_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.X509Certificate = exports.X509Secret = exports.implementsIdentification = exports.IdentificationStatus = exports.IdentificationVariant = void 0;
const error_1 = require("./error");
const jsrsasign_1 = require("jsrsasign");
const conversion_1 = require("./utils/conversion");
const predicates_1 = require("./utils/predicates");
/**
 * Identification Variant, clon de la versión de Rust de este código, emulando un enum en Rust.
 */
class IdentificationVariant {
    /**
     * Construye una variante de certificado. De momento sólo existen los x509, pero el SAT emitirá distintos tipos de certificado.
     *
     * @param identification Identificación con la que se construye la variante
     */
    constructor(identification) {
        /**
         * Indica si el tipo de certificado contenido es un x509
         *
         * @returns verdadero si el certificado contenido es un x509
         */
        this.is_x509_certificate = () => {
            return true;
        };
        /**
         * Regresa un certificado x509, en caso de existir dentro de la variante.
         *
         * @returns Un certificado x509 en caso de estar contenido en la variante, null en otro caso.
         */
        this.as_x509_certificate = () => {
            return this.x509_certificate;
        };
        // Esto se actualizará con futuras identificaciones
        this.x509_certificate = identification;
    }
}
exports.IdentificationVariant = IdentificationVariant;
(function (IdentificationVariant) {
    /**
     * Intenta "deserializar" una cadena o un ArrayBuffer como una identificación.
     *
     * @returns La firma, o en su caso, un error
     */
    function parse(source) {
        if (isString(source)) {
            let res = X509Certificate.from_string(source);
            if (!(0, predicates_1.isError)(res)) {
                return new IdentificationVariant(res);
            }
        }
        else {
            let res = X509Certificate.from_bytes(source);
            if (!(0, predicates_1.isError)(res)) {
                return new IdentificationVariant(res);
            }
        }
        return new error_1.Error(error_1.ErrorCode.WrongStructure, "source != IdentificationVariant");
    }
    IdentificationVariant.parse = parse;
})(IdentificationVariant = exports.IdentificationVariant || (exports.IdentificationVariant = {}));
/**
 * Posibles estados de validación de estado de una identificación
 */
var IdentificationStatus;
(function (IdentificationStatus) {
    /// El certificado es Válido
    IdentificationStatus[IdentificationStatus["Valid"] = 0] = "Valid";
    /// El certificado es criptográficamente válido, pero no se revisó en línea
    IdentificationStatus[IdentificationStatus["ValidOffline"] = 1] = "ValidOffline";
    /// El certificado está revocado, y no hay información de hora
    IdentificationStatus[IdentificationStatus["RevokedNoTime"] = 2] = "RevokedNoTime";
    /// El certificado está revocado, con fecha de revocación específica. we need to find how to get the revocation date
    IdentificationStatus[IdentificationStatus["Revoked"] = 3] = "Revoked";
    /// El certificado está corrupto
    IdentificationStatus[IdentificationStatus["Corrupted"] = 4] = "Corrupted";
    /// El certificado está expirado
    IdentificationStatus[IdentificationStatus["Expired"] = 5] = "Expired";
    /// El certificado no es válido aún
    IdentificationStatus[IdentificationStatus["NotYetValid"] = 6] = "NotYetValid";
    /// No se pudo verificar, y viene la descripción como cadena de caracteres. We need to find how to get the detail of the failed verification
    IdentificationStatus[IdentificationStatus["CouldNotVerify"] = 7] = "CouldNotVerify";
})(IdentificationStatus = exports.IdentificationStatus || (exports.IdentificationStatus = {}));
/// This function needs to be used for every class that pretends to be an identification
function implementsIdentification() {
    return (constructor) => { constructor; };
}
exports.implementsIdentification = implementsIdentification;
/*****************************************************************
 * Implementation of the X509 Certificate Identification Variant *
 *****************************************************************/
// Función que determina si el valor JSON es una cadena
function isString(candidate) {
    return candidate.endsWith !== undefined;
}
class X509Secret {
    static deserialize(content, pass) {
        let real_key = undefined;
        try {
            if (isString(content)) {
                real_key = jsrsasign_1.KEYUTIL.getKey(content, pass);
            }
            else {
                let key_str = "-----BEGIN ENCRYPTED PRIVATE KEY-----\n" + (0, conversion_1.bytes2Base64)(new Uint8Array(content)) + "\n-----END ENCRYPTED PRIVATE KEY-----\n";
                real_key = jsrsasign_1.KEYUTIL.getKey(key_str, pass);
            }
        }
        catch (error) {
            console.log(error);
            return new error_1.Error(error_1.ErrorCode.WrongPass);
        }
        let instance = new X509Secret();
        instance.inner = real_key;
        return instance;
    }
}
exports.X509Secret = X509Secret;
let X509Certificate = X509Certificate_1 = class X509Certificate {
    constructor() {
        /// Serialization function for the certificate, into one of the string formats
        this.to_string = () => {
            return this.cert_string;
        };
        /// Function meant to return the unique identifier ID string for the certificate
        this.get_unique_id = () => {
            return this.unique_id;
        };
        /// Function to get the name associated to the certificate. Does not need to be unique.
        this.get_name = () => {
            return this.name;
        };
        /// Function to get the id of the issuer of this certificate
        this.get_issuer_id = () => {
            return this.issuer_unique_id;
        };
        /// Function that signs a stream of bytes
        this.sign = (target, secret) => {
            var sig = new jsrsasign_1.KJUR.crypto.Signature({ alg: "SHA256withRSA" });
            sig.init(secret.inner);
            // We create the hex string
            let content = (0, conversion_1.bytes2hex)(target);
            sig.updateHex(content);
            // Esta cadena hexadecimal contiene la cadena firmada.
            var hexSigned = sig.sign();
            // Antes de salir de la función, tenemos que verificar que el certificado desencripta la llave...
            let pub_key = this.inner.getPublicKey();
            var ret_sig = new jsrsasign_1.KJUR.crypto.Signature({ alg: "SHA256withRSA" });
            // Esta vez comenzamos con la llave pública
            ret_sig.init(pub_key);
            // Pasamos el mismo contenido
            ret_sig.updateHex(content);
            if (ret_sig.verify(hexSigned)) {
                // Firma correcta, la regresamos como stream de bytes
                return (0, conversion_1.hex2bytes)(hexSigned);
            }
            else {
                // Regresamos un error
                // return {express: ():string => "La llave privada no coincide con el certificado"}
                return new error_1.Error(error_1.ErrorCode.WrongPass);
            }
        };
        /// Function to verify a stream of bytes, apparently sign with this credential
        this.verify = (signature, original) => {
            let pub_key = this.inner.getPublicKey();
            var sig = new jsrsasign_1.KJUR.crypto.Signature({ alg: "SHA256withRSA" });
            // Esta vez comenzamos con la llave pública
            sig.init(pub_key);
            let target = (0, conversion_1.bytes2hex)(original);
            let source = (0, conversion_1.bytes2hex)(signature);
            sig.updateHex(target);
            return sig.verify(source);
        };
    }
    /// Function that loads an identification from a string
    static from_string(content) {
        // The certificate that will be handed in to the user
        let x = new X509Certificate_1();
        x.cert_string = content;
        // An inner reference to an x509
        let a = new jsrsasign_1.X509();
        a.readCertPEM(content);
        x.inner = a;
        // Something like common name from the issuer -> cert.inner.getIssuerString();
        // Something like common name from the subject -> cert.inner.getSubjectString();
        // Esta cosa tiene back-slashes separar los campos...
        let subject_string = a.getSubjectString();
        let accumulator = new Map();
        // Esto es para separar cada token en sus dos posibles valores
        const dictionarize = (currentValue) => {
            let tokens = currentValue.split("=");
            if (tokens.length == 2) {
                accumulator.set(tokens[0], tokens[1]);
            }
        };
        subject_string.replace("\\/", "|").split("/").map(dictionarize);
        // Esta línea se añade por la marciana manera de poner ambos certificados en el RFC
        x.rfc = accumulator.get("uniqueIdentifier").split("|")[0].trim();
        x.name = accumulator.get('O');
        x.unique_id = a.getSerialNumberHex();
        let ch = x.unique_id[23];
        // Now the tricky issuer serial part
        if (ch == '4') {
            // We pass back the serial number that corresponds to the AC_4
            x.issuer_unique_id = "275106190556405255191281850864241509582309963827";
        }
        else if (ch == '5') {
            // We pass back the serial number that corresponds to the AC_5
            x.issuer_unique_id = "275106190556405255191281850864241509582310027318";
        }
        else if (ch == '6') {
            // We pass back the serial number that corresponds to the AC_5
            x.issuer_unique_id = "275106190556405255191281850864241509582310029369";
        }
        else if (ch == '7') {
            // We pass back the serial number that corresponds to the AC_5
            x.issuer_unique_id = "275106190556405255191281850864241509582310029616";
        }
        else {
            // Unlickyly, we have to ignore certificates
            x.issuer_unique_id = "N/A";
        }
        return x;
    }
    /// Function that is meant to return the extensions associated to binary files
    static string_extensions() {
        return new Set(["pem"]);
    }
    /// Function that loads a certificate from a stream of bytes, meaning binary files
    static from_bytes(content) {
        let x = new X509Certificate_1();
        let a = new jsrsasign_1.X509();
        // We need to base64 encode the content of this binary thing, and surround it with begin/end tags
        let certificate = "-----BEGIN CERTIFICATE-----\n" + (0, conversion_1.bytes2Base64)(new Uint8Array(content)) + "\n-----END CERTIFICATE-----\n";
        return X509Certificate_1.from_string(certificate);
    }
    /// Function that is meant to return the extensions associated to binary files
    static bytes_extensions() {
        return new Set(["cer", "der"]);
    }
    /* Functions available only to an X509Certificate */
    get_inner() {
        return this.inner;
    }
    get_rfc() {
        return this.rfc;
    }
    /**********************
     * Additional methods *
     **********************/
    parse_secret(source, password) {
        return X509Secret.deserialize(source, password);
    }
};
X509Certificate = X509Certificate_1 = __decorate([
    implementsIdentification() /* this statement implements both normal interface & static interface */
], X509Certificate);
exports.X509Certificate = X509Certificate;
//# sourceMappingURL=identification.js.map